import React, { FC } from 'react';

import Button, { IButtonProps } from '@ui/atoms/Button';
import FlexColumn from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import aligned from '@ui/styled/Aligned';
import spaced, { ISpaced } from '@ui/styled/Spaced';

import { IPageProps } from '@folx-types/flow-steps';

export interface IMedicationDeliveryPostSubmitPreferredPharmacyStepPageContent {
	heading: string;
	confirmationMessage: string;
	cta: string;
}

interface IMedicationDeliveryPostSubmitPreferredPharmacyStepProps extends IPageProps {
	pageContent: IMedicationDeliveryPostSubmitPreferredPharmacyStepPageContent;
}

const AlignedButton = aligned<IButtonProps & ISpaced>(spaced<IButtonProps>(Button));
const SpacedHeadingText = spaced(HeadingText);

const MedicationDeliveryPostSubmitPreferredPharmacyStep: FC<
	IMedicationDeliveryPostSubmitPreferredPharmacyStepProps
> = ({ pageContent }) => {
	const { heading, confirmationMessage, cta } = pageContent;

	return (
		<FlexColumn>
			<SpacedHeadingText marginBottom="md">{heading}</SpacedHeadingText>
			<WYSIWYGContent dangerouslySetInnerHTML={{ __html: confirmationMessage }} />
			<AlignedButton alignSelf="center" marginTop="lgxl" label={cta} labelSize="sm" href="../.." />
		</FlexColumn>
	);
};

export default MedicationDeliveryPostSubmitPreferredPharmacyStep;
